import React from 'react';
import { connect } from 'react-redux';
import { getDic } from '../assets/i18n/dictionary';
import { insertNewAccess, getSystemActions } from '../services/accessService';
import {
  getCalendarListApi,
  addNewCalendarApi,
  updateCalendarApi,
  deleteCalendarApi,
  convertCalendarObjectToIcsFile,
  convertCalendarObjectToIcsOutlookFile,
  convertCalendarObjectToGoogleCalendarLink
} from '../services/calendarService';
import { createCalendarModel, convertFormToCalendarObject, convertCalendarObjectToForm } from '../models/calendarModel';
import { validateForm } from '../utils';
import moment from 'moment';
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/DeleteForever';
import CalendarIcon from '@material-ui/icons/CalendarToday';

//Imports de components
import {
  MenuButton,
  BackButton,

  Alert,
  Loading,
  Container,
  FormRow,
  FormColumn,
  GridRow,
  GridCell,
  TextMedium,
  Button,
  Dialog,
  InputFieldOutlined,
  TextSmall,
  InfiniteScroll,
  SelectList,
  Modal,
  Link,
  ModalConcatUrl,
} from '../components';

const CalendarRegisterPage = (props) => {
  const [state, setState] = React.useState(true);

  //Alert control
  const [alertOpen, setAlertOpen] = React.useState(false);
  const [alertTitle, setAlertTitle] = React.useState("");
  const [alertMessage, setAlertMessage] = React.useState("");

  //Loading control
  const [loadingMessage, setLoadingMessage] = React.useState(getDic("carregando"));
  const [openLoading, setOpenLoading] = React.useState(true);

  //Dialog control
  const [dialogConfirmOpen, setDialogConfirmOpen] = React.useState(false);
  const [dialogConfirmKey, setDialogConfirmKey] = React.useState("");
  const [dialogConfirmKeyErrorMessage, setDialogConfirmKeyErrorMessage] = React.useState("");

  //Modal Control
  const [openModal, setOpenModal] = React.useState(false);

  const [calendarList, setCalendarList] = React.useState([]);
  const [chosenCalendar, setChosenCalendar] = React.useState(null);
  const [newCalendarForm, setNewCalendarForm] = React.useState([]);

  React.useEffect(() => {
    //Bloqueio caso o usuário não seja admin
    if (!props.user.isAdmin) {
      props.history.goBack();
    }

    var helpButton = document.getElementById("launcher");
    if (helpButton) {
      helpButton.style.visibility = 'hidden';
    }

    getPageData();
    insertNewAccess(props.match.url, "", getSystemActions().accessPage);

    return () => {
      var helpButton = document.getElementById("launcher");
      if (helpButton) {
        helpButton.style.visibility = 'visible';
      }
      insertNewAccess(props.match.url, "", getSystemActions().exitPage);
    }
  }, []);

  const getPageData = async () => {
    setOpenLoading(true);

    getCalendarListApi()
      .then(res => {
        setCalendarList(res);
      })
      .catch(err => {
        setAlertOpen(true);
        setAlertTitle(getDic("erro"));
        setAlertMessage(getDic("sem-conexao"));
      })
      .finally(() => {
        setOpenLoading(false);
      });
  }

  const onChangeHandler = (index, value) => {
    var _newForm = newCalendarForm;
    _newForm[index].value = value;
    setNewCalendarForm(_newForm);
    setState(state === true ? false : true);
  }

  const resetCalendarForm = () => {
    const _newCalendar = createCalendarModel();
    const _newForm = convertCalendarObjectToForm(_newCalendar);
    setNewCalendarForm(_newForm);
  }

  const createNewCalendar = () => {
    const _newCalendar = createCalendarModel();
    const _newForm = convertCalendarObjectToForm(_newCalendar);
    setNewCalendarForm(_newForm);
    setOpenModal(true);
  }

  const editCalendar = (calendar) => {
    const _newForm = convertCalendarObjectToForm(calendar);
    setNewCalendarForm(_newForm);
    setOpenModal(true);
  }

  const inactiveCalendar = () => {
    setOpenLoading(true);
    setLoadingMessage(getDic("salvando"));

    deleteCalendarApi(chosenCalendar.id)
      .then(res => {
        const _newCalendarList = [];
        calendarList.forEach(item => {
          if (item.id !== chosenCalendar.id) {
            _newCalendarList.push(item);
          }
        });

        setCalendarList(_newCalendarList);
        setAlertOpen(true);
        setAlertTitle("");
        setAlertMessage(getDic("enviado-sucesso"));
      })
      .catch(err => {
        setAlertOpen(true);
        setAlertTitle(getDic("erro"));
        setAlertMessage(getDic("enviado-erro"));
        setOpenLoading(false);
      })
      .finally(() => {
        setOpenLoading(false);
      })
  }

  const saveCalendar = async () => {
    var validation = validateForm(newCalendarForm);
    if (validation.isValid) {

      var _newCalendar = convertFormToCalendarObject(newCalendarForm);

      setOpenLoading(true);
      setLoadingMessage(getDic("salvando"));

      _newCalendar.eventId = props.event.id;

      var _error = false;
      const _newCalendarList = [];

      if (_newCalendar.id > 0) {
        await updateCalendarApi(_newCalendar)
          .then(res => {
            _newCalendarList.push(res);
          })
          .catch(err => {
            _error = true;
          })
      }
      else {
        await addNewCalendarApi(_newCalendar)
          .then(res => {
            _newCalendar.id = res.id;
            _newCalendarList.push(_newCalendar);
          })
          .catch(err => {
            _error = true;
          })
      }

      if (_error) {
        setAlertOpen(true);
        setAlertTitle(getDic("erro"));
        setAlertMessage(getDic("enviado-erro"));
        setOpenLoading(false);
      }
      else {
        getPageData();
        setAlertOpen(true);
        setAlertTitle("");
        setAlertMessage(getDic("enviado-sucesso"));
        resetCalendarForm();
        setOpenLoading(false);
        setOpenModal(false);
      }
    }
    else {
      setNewCalendarForm(validation.form);
    }
  }

  const getIcsFile = (calendarObj) => {
    convertCalendarObjectToIcsFile(calendarObj);
  }

  const getIcsOutlookFile = (calendarObj) => {
    convertCalendarObjectToIcsOutlookFile(calendarObj);
  }

  const getGoogleCalendarLink = async (calendarObj) => {
    const _url = await convertCalendarObjectToGoogleCalendarLink(calendarObj);
    let a = document.createElement("a");
    a.href = _url;
    a.target = "_blank";
    a.click();
  }

  return (
    <Container background="#e8eced" align="center">
      <FormRow align="center" background="#e8eced" margin="0px">
        <div>
          <MenuButton history={props.history} />
          <BackButton history={props.history} color="#212121">
            {getDic("voltar").toUpperCase()}
          </BackButton>

        </div>

        <FormRow
          minHeight="60px"
          align="center"
          background="#e8eced"
          margin="0px"
        />
        <FormRow
          minHeight="60px"
          align="flex-end"
          background="#e8eced"
          margin="0px"
          paddingTop="5px"
        >
          <div style={{ paddingRight: "10px", maxWidth: "400px" }}>
            <Button
              color="green"
              textColor="white"
              onClick={() => createNewCalendar()}
            >
              {`${getDic("cadastrar")} ${getDic("calendario")}`}
            </Button>
          </div>
        </FormRow>

        <FormColumn align="center" background="#e8eced" margin="0px" padding="5px">
          {calendarList.length > 0 ? (
            <InfiniteScroll
              pageStart={0}
              dataLength={calendarList.length}
              height={"79vh"}
            >
              <GridRow backgroundColor="#d9d9d9">
                <GridCell width="10%" border top first>
                  <TextMedium>ID</TextMedium>
                </GridCell>
                <GridCell width="30%" border top>
                  <TextMedium>{getDic("titulo").toUpperCase()}</TextMedium>
                </GridCell>
                <GridCell width="15%" border top>
                  <TextMedium>{getDic("data").toUpperCase()} {getDic("inicio").toUpperCase()}</TextMedium>
                </GridCell>
                <GridCell width="15%" border top>
                  <TextMedium>{getDic("data").toUpperCase()} {getDic("fim").toUpperCase()}</TextMedium>
                </GridCell>
                <GridCell width="15%" border top>
                  <TextMedium>{getDic("tipo").toUpperCase()}</TextMedium>
                </GridCell>
                <GridCell width="15%" border top>
                  <TextMedium>{getDic("acao").toUpperCase()}</TextMedium>
                </GridCell>
              </GridRow>

              {calendarList.map((item, i) => {
                return (
                  <GridRow
                    key={item.id}
                    autoColor={i}
                  >
                    <GridCell width="10%" border first>
                      <TextMedium>{item.id}</TextMedium>
                    </GridCell>
                    <GridCell width="30%" border>
                      <TextMedium>{item.title}</TextMedium>
                    </GridCell>
                    <GridCell width="15%" border>
                      <TextMedium>{moment(item.startDate).format("DD/MM/YYYY - hh:mm")}</TextMedium>
                    </GridCell>
                    <GridCell width="15%" border>
                      <TextMedium>{moment(item.endDate).format("DD/MM/YYYY - hh:mm")}</TextMedium>
                    </GridCell>
                    <GridCell width="15%" border>
                      <TextMedium>{item.type}</TextMedium>
                    </GridCell>
                    <GridCell width="15%" border>
                      <button onClick={() => getIcsFile(item)}>
                        {getDic("gerar")} ICS
                      </button>
                      <button onClick={() => getIcsOutlookFile(item)}>
                        {getDic("gerar")} Outlook
                      </button>
                      <button onClick={() => getGoogleCalendarLink(item)}>
                        {getDic("gerar")} Google Link
                      </button>
                      <EditIcon onClick={() => editCalendar(item)} style={{ cursor: "pointer" }} />
                      <DeleteIcon
                        onClick={() => {
                          setChosenCalendar(item);
                          setDialogConfirmOpen(true);
                        }}
                        style={{ cursor: "pointer" }}
                      />
                    </GridCell>
                  </GridRow>
                );
              })}
            </InfiniteScroll>
          ) : (
            <TextMedium>{getDic("pesquisa-sem-resultado")}</TextMedium>
          )}
        </FormColumn>

        <Modal
          isVideo
          height="80vh"
          open={openModal}
          closeButtonClick={e => setOpenModal(false)}
          onClose={ret => {
            setOpenModal(false);
          }}
        >
          <Container background="#e8eced" align="left" height="100%" >
            <FormColumn padding="5px" margin="0px" background="#e8eced">
              {newCalendarForm.map((item, i) => {
                if (i === 0) {
                  return (
                    <>
                      <FormRow key={item.id} align="center" paddingTop="7px">
                        <TextMedium>
                          {item.value > 0 ? (
                            `${getDic("editar")} ${getDic("calendario")}`
                          ) : (
                            `${getDic("nova")} ${getDic("calendario")}`
                          )}
                        </TextMedium>
                      </FormRow>
                    </>
                  )
                }
                else {
                  if (item.dbReference === "typeId" || item.dbReference === "location" || item.dbReference === "idLocation") {
                    return (<></>);
                  }
                  else if (item.type === "select" && item.values) {
                    return (
                      <FormRow key={item.id} align="center" paddingTop="7px">
                        <SelectList
                          required={item.required}
                          error={item.error}
                          errorMessage={item.errorMessage}
                          title={item.name}
                          width="100%"
                          value={item.value}
                          menuItens={item.values}
                          onChange={async (event) =>
                            onChangeHandler(i, event.target.value)
                          }
                          multiple={Array.isArray(item.value) ? true : false}
                        />
                      </FormRow>
                    );
                  }
                  else {
                    return (
                      <FormRow key={item.id} align="center" paddingTop="7px">
                        <InputFieldOutlined
                          key={item.id}
                          required={item.required}
                          maxLength={item.maxLength}
                          error={item.error}
                          errorMessage={item.errorMessage}
                          value={item.value}
                          title={item.name}
                          type={item.type}
                          onChange={(event) => {
                            onChangeHandler(i, event.target.value)
                          }}
                        />
                      </FormRow>
                    );
                  }
                }
              })}
              <FormRow align="center" paddingTop="7px">
                <Button
                  text={getDic("salvar")}
                  onClick={() => saveCalendar()}
                />
              </FormRow>
            </FormColumn>
          </Container>
        </Modal>

        <Alert
          open={alertOpen}
          onClose={() => setAlertOpen(false)}
          onClick={() => setAlertOpen(false)}
          title={alertTitle}
          message={alertMessage}
        />

        <Dialog
          open={dialogConfirmOpen}
          onClose={() => setDialogConfirmOpen(false)}
          title={getDic("atencao")}
          textButtonYes={getDic("inativar")}
          onClickYes={() => {
            if (dialogConfirmKey && dialogConfirmKey != "" && dialogConfirmKey.toUpperCase() === "SIM") {
              inactiveCalendar();
              setDialogConfirmOpen(false);
              setDialogConfirmKey("");
            }
            else {
              setDialogConfirmKeyErrorMessage(true);
              setTimeout(() => {
                setDialogConfirmKeyErrorMessage(false);
              }, 3000); // 1 minuto = 60000
            }
          }}
          textButtonNo={getDic("cancelar")}
          onClickNo={() => {
            setDialogConfirmOpen(false);
            setDialogConfirmKey("");
          }}
        >
          <FormRow>
            <TextSmall>
              {getDic("confirmacao-de-acao")}
            </TextSmall>
          </FormRow>
          <FormRow align="center" paddingTop="5px">
            <InputFieldOutlined
              key="password"
              value={dialogConfirmKey}
              onChange={event => setDialogConfirmKey(event.target.value)}
            />
          </FormRow>
          {dialogConfirmKeyErrorMessage ? (
            <TextSmall color="red">{getDic("erro")}</TextSmall>
          ) : (null)}
        </Dialog>

        <Loading open={openLoading} message={loadingMessage} />
      </FormRow>
    </Container>
  )
}

function mapStateToProps(state) {
  return {
    event: state.event,
    user: state.user,
  }
}

export default connect(mapStateToProps, null)(CalendarRegisterPage);
